const API_BASE = '/api';

let authToken = localStorage.getItem('adminToken') || '';

// Helper function with timeout
const fetchWithTimeout = async (url, options = {}, timeout = 10000) => {
   const controller = new AbortController();
   const id = setTimeout(() => controller.abort(), timeout);
   try {
      const response = await fetch(url, {
         ...options,
         signal: controller.signal,
      });
      clearTimeout(id);
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response;
   } catch (error) {
      clearTimeout(id);
      throw error;
   }
};

export const setAuthToken = (token) => {
   authToken = token;
   localStorage.setItem('adminToken', token);
};

export const getAuthToken = () => authToken;

export const clearAuthToken = () => {
   authToken = '';
   localStorage.removeItem('adminToken');
};

// Auth
export const login = async (password) => {
   const res = await fetch(`${API_BASE}/auth`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
   });
   const data = await res.json();
   if (data.success) {
      setAuthToken(data.token);
   }
   return data;
};

// Videos
export const getVideos = async () => {
   const res = await fetchWithTimeout(`${API_BASE}/videos`);
   return res.json();
};

export const addVideo = async (video) => {
   const res = await fetch(`${API_BASE}/videos`, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': authToken,
      },
      body: JSON.stringify(video),
   });
   return res.json();
};

export const updateVideo = async (id, video) => {
   const res = await fetch(`${API_BASE}/videos/${id}`, {
      method: 'PUT',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': authToken,
      },
      body: JSON.stringify(video),
   });
   return res.json();
};

export const deleteVideo = async (id) => {
   const res = await fetch(`${API_BASE}/videos/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': authToken },
   });
   return res.json();
};

// Image upload (공연 포스터)
export const uploadImage = async (file) => {
   const formData = new FormData();
   formData.append('file', file);
   const res = await fetch(`${API_BASE}/upload`, {
      method: 'POST',
      headers: { 'Authorization': authToken },
      body: formData,
   });
   let data;
   try {
      data = await res.json();
   } catch (e) {
      data = null;
   }
   if (!res.ok) {
      throw new Error((data && data.error) || '이미지 업로드에 실패했습니다');
   }
   return data;
};

// Events
export const getEvents = async () => {
   const res = await fetchWithTimeout(`${API_BASE}/events`);
   return res.json();
};

export const addEvent = async (event) => {
   const res = await fetch(`${API_BASE}/events`, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': authToken,
      },
      body: JSON.stringify(event),
   });
   return res.json();
};

export const updateEvent = async (id, event) => {
   const res = await fetch(`${API_BASE}/events/${id}`, {
      method: 'PUT',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': authToken,
      },
      body: JSON.stringify(event),
   });
   return res.json();
};

export const deleteEvent = async (id) => {
   const res = await fetch(`${API_BASE}/events/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': authToken },
   });
   return res.json();
};
